const SvgAssetManagement1 = (props) => (
  <>
    <defs />
    <path
      d="m48 336 98-98M336 336l-98-98M192 0v128M192 256v128M384 192H256"
      stroke="#042068"
      strokeMiterlimit={10}
      strokeWidth="3px"
      fill="none"
    />
    <path d="m192.72 191.87.54.55" fill="none" strokeWidth={0} />
    <path d="m48 48 98 98M336 48l-98 98" stroke="#042068" strokeMiterlimit={10} strokeWidth="3px" fill="none" />
    <path d="m192.17 192.42.55-.55" fill="none" strokeWidth={0} />
    <path
      d="M128 192c0-17.77 7.25-33.85 18.94-45.45M256 192c0-17.76-7.24-33.83-18.92-45.43M128 192c0 17.57 7.08 33.49 18.55 45.05M237.08 146.57C225.51 135.09 209.59 128 192 128M192 256c17.76 0 33.83-7.24 45.43-18.92M192 256c-17.78 0-33.86-7.25-45.45-18.95M256 192c0 17.58-7.09 33.51-18.57 45.08M146.94 146.55C158.51 135.08 174.42 128 192 128"
      stroke="#042068"
      strokeMiterlimit={10}
      strokeWidth="3px"
      fill="none"
    />
    <circle cx={192} r={8} fill="#0f62fe" strokeWidth={0} />
    <path d="M128 192H0" stroke="#042068" strokeMiterlimit={10} strokeWidth="3px" fill="none" />
    <circle cy={192} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={384} cy={192} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={336} cy={48} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={336} cy={336} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={192} cy={384} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={48} cy={336} r={8} fill="#0f62fe" strokeWidth={0} />
    <circle cx={48} cy={48} r={8} fill="#0f62fe" strokeWidth={0} />
  </>
);

export default SvgAssetManagement1;
